<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">
      <span>我的页面配置 / 新增</span>
      <el-button class="back" type="primary" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>

    <div class="form-wrapper">
      <el-form
        class="advert-popup-form"
        label-width="120px"
        label-position="left"
        :model="formData"
        :rules="formRules"
        ref="formRef"
      >
        <el-form-item label="类型" prop="type">
          <el-select placeholder="请选择类型" v-model="formData.type">
            <el-option label="运动服务" :value="1"></el-option>
            <el-option label="常用功能" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模块ID" prop="moduleId">
          <el-input
            placeholder="请输入ID"
            v-model="formData.moduleId"
          ></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input placeholder="请输入名称" v-model="formData.name">
          </el-input>
        </el-form-item>
        <el-form-item label="顺序">
          <el-input-number v-model="formData.order" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="链接" prop="jumpUrl">
          <el-input v-model="formData.jumpUrl"></el-input>
        </el-form-item>
        <el-form-item
          label="是否弹窗提示"
          required
          class="popup-prompt-form-item"
        >
          <div class="popup-prompt-row">
            <el-radio-group v-model="formData.isPopup">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
            <el-input
              v-if="formData.isPopup === 1"
              v-model="formData.popupContent"
              maxlength="20"
              placeholder="请填写弹窗内容，最多20个字"
              class="popup-prompt-input"
            />
            <div class="popup-prompt-example">
              <span class="popup-prompt-example-label">示例</span>
              <img :src="popupPromptExampleImg" alt="弹窗示例" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="素材" prop="iconUrl">
          <SUpload
            v-model="formData.iconUrl"
            accept="image/*"
            type="drag"
            :size="50"
            actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=1"
            :show-file-list="false"
          />
          <div class="supload-tips">
            建议尺寸40*40，大小≤50KB，优先SVG其次png
          </div>
          <!-- <UploadImage
            actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=1"
            tips="支持 jpg、png、gif）"
            :urls="formData.iconUrl"
            @onUrls="imageUploaded"
          >
          </UploadImage> -->
        </el-form-item>
        <el-form-item label="学校" prop="scopeType" required>
          <div class="school-section">
            <div class="school-scope-row">
              <span class="label-text">涉及院系：</span>
              <el-radio-group v-model="formData.scopeType">
                <el-radio :label="1">全部</el-radio>
                <el-radio :label="2">部分</el-radio>
              </el-radio-group>
            </div>

            <div class="campus-zone-section">
              <div class="section-label">
                {{ formData.scopeType === 1 ? "屏蔽校区" : "应用校区" }}
              </div>
              <div
                style="display: flex; align-items: center; margin-bottom: 8px"
              >
                <el-select
                  v-model="selectedCampusUnid"
                  placeholder="请选择校区"
                  filterable
                  style="flex: 1; margin-right: 8px"
                >
                  <el-option
                    v-for="item in campusZoneList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-button @click="handleAddCampus">添加</el-button>
              </div>
              <div class="campus-list-wrap">
                <div
                  v-for="item in formData.campusList"
                  :key="item.value"
                  class="campus-item"
                >
                  <span>{{ item.label }}</span>
                  <el-button
                    type="text"
                    icon="circle-close"
                    @click="handleDeleteCampus(item.value)"
                  ></el-button>
                </div>
              </div>
              <div class="campus-footer">
                共计{{ formData.campusList.length }}所学校
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div class="margin-20">
      <el-button type="primary" @click="clickSave()">保存</el-button>
    </div>
  </div>
</template>

<script>
import UploadImage from "../../../../components/UploadItems/UploadImage.vue";
import popupPromptExampleImg from "../../../../assets/popup-prompt-example.png";

export default {
  components: {
    UploadImage,
  },

  data() {
    return {
      loading: false,
      id: "",
      campusZoneList: [], // 所有校区列表
      selectedCampusUnid: null, // 当前选中的校区
      originalData: null, // 保存原始数据，用于对比是否需要更新关系
      popupPromptExampleImg,
      formData: {
        moduleId: "",
        name: "",
        order: 1,
        type: "",
        jumpUrl: "",
        iconUrl: "",
        status: 0,
        scopeType: 1, // 可见范围：1-全部可见，2-部分可见
        campusList: [], // 已选择的校区列表
        isPopup: 0,
        popupContent: "",
      },
      formRules: {
        moduleId: {
          type: "string",
          required: true,
          message: "请输入模块ID",
          trigger: "blur",
        },
        name: { required: true, message: "请输入名称", trigger: "blur" },
        type: {
          type: "number",
          required: true,
          message: "请选择类型",
          trigger: "blur",
        },
        jumpUrl: { required: true, message: "请输入链接", trigger: "blur" },
        iconUrl: { required: true, message: "请上传素材", trigger: "change" },
        scopeType: {
          type: "number",
          required: true,
          message: "请选择涉及院系",
          trigger: "change",
        },
      },
    };
  },

  mounted() {
    const queryInfo = this.$route.query;
    if (queryInfo.id) {
      this.id = queryInfo.id;
      // 先加载校区列表，然后再加载详情
      this.apiGetCampusZones().then(() => {
        this.queryDetailInfo();
      });
    } else {
      // 新增时只需要加载校区列表
      this.apiGetCampusZones();
    }
  },

  methods: {
    // 查询详情信息
    queryDetailInfo() {
      this.loading = true;
      this.$http({
        url: this.$util.domain + "/app-modules/detail",
        method: "GET",
        params: { id: this.id },
      })
        .then((res) => {
          if (res.body.data && JSON.stringify(res.body.data) !== "{}") {
            const data = res.body.data;

            // 保存原始数据用于对比
            this.originalData = {
              scopeType: data.scopeType || 1,
              unidList: data.unidList || [],
            };

            this.formData = {
              moduleId: data.moduleId + "",
              name: data.name,
              order: data.order,
              type: data.type,
              jumpUrl: data.jumpUrl,
              iconUrl: data.iconUrl,
              status: data.status,
              scopeType: data.scopeType || 1,
              campusList: [],
              isPopup: data.isPopup != null ? data.isPopup * 1 : 0,
              popupContent: data.popupContent || "",
            };

            // 转换 unidList 为 campusList
            if (data.unidList && data.unidList.length > 0) {
              this.formData.campusList = data.unidList.map((unid) => {
                const campus = this.campusZoneList.find(
                  (item) => item.value === unid
                );
                if (campus) {
                  return campus;
                } else {
                  // 如果找不到，显示警告但仍然添加
                  console.warn(`未找到校区 ID: ${unid}`);
                  return { label: `校区${unid}`, value: unid };
                }
              });
            }
          }
        })
        .catch((error) => {
          this.$util.errorMsg("获取详情信息失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 发送信息
    sendInfo() {
      if (this.formData.isPopup === 1 && !this.formData.popupContent.trim()) {
        this.$util.errorMsg("请填写弹窗内容");
        return;
      }

      this.loading = true;

      // 转换 campusList 为 unidList
      const unidList = this.formData.campusList.map((item) => item.value);

      // 判断是否需要更新关系表
      let needUpdateRelation = true; // 默认为 true

      // 编辑时：检查 scopeType 和 unidList 是否有变化
      if (this.id && this.originalData) {
        const scopeTypeChanged =
          this.originalData.scopeType !== this.formData.scopeType;

        // 对比 unidList 是否变化
        const originalUnidList = [...this.originalData.unidList].sort();
        const currentUnidList = [...unidList].sort();
        const unidListChanged =
          JSON.stringify(originalUnidList) !== JSON.stringify(currentUnidList);

        // 只有在 scopeType 或 unidList 变化时才需要更新关系
        needUpdateRelation = scopeTypeChanged || unidListChanged;
      }

      // 构建提交参数，根据API文档要求的字段
      const params = {
        name: this.formData.name,
        order: this.formData.order,
        jumpUrl: this.formData.jumpUrl,
        iconUrl: this.formData.iconUrl,
        moduleId: parseInt(this.formData.moduleId),
        type: this.formData.type,
        status: this.formData.status,
        appType: 0, // 0-学生端
        scopeType: this.formData.scopeType,
        unidList: unidList,
        needUpdateRelation: needUpdateRelation,
        isPopup: this.formData.isPopup * 1,
        popupContent:
          this.formData.isPopup === 1 ? this.formData.popupContent.trim() : "",
      };

      // 编辑时需要传ID
      if (this.id) {
        params.id = parseInt(this.id);
      }

      // 根据是否有ID选择接口
      const apiUrl = this.id
        ? this.$util.domain + "/app-modules/edit"
        : this.$util.domain + "/app-modules/add";

      this.$http({
        url: apiUrl,
        method: "POST",
        dataType: "json",
        body: JSON.stringify(params),
      })
        .then((res) => {
          if (res.body.error === 10000) {
            this.$message.success(this.id ? "编辑成功" : "新增成功");
            this.$router.go(-1);
          } else {
            this.$util.errorMsg(res.body.message);
          }
        })
        .catch((err) => {
          this.$util.errorMsg(err.message || "操作失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 图片上传成功
    imageUploaded(img) {
      this.formData.iconUrl = img;
    },
    // 点击保存
    clickSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.sendInfo();
        }
      });
    },
    // 获取所有校区
    apiGetCampusZones() {
      return this.$http({
        url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
        method: "GET",
      })
        .then((res) => {
          if (res.body.data && res.body.data.length) {
            this.campusZoneList = res.body.data.map((item) => ({
              label: item.name,
              value: item.unid,
            }));
          } else {
            this.campusZoneList = [];
          }
          return Promise.resolve();
        })
        .catch((error) => {
          this.campusZoneList = [];
          this.$util.errorMsg("获取校区列表失败");
          return Promise.reject(error);
        });
    },
    // 添加校区
    handleAddCampus() {
      if (!this.selectedCampusUnid) {
        return;
      }
      // 检查是否已经添加
      const exists = this.formData.campusList.find((item) => {
        return item.value === this.selectedCampusUnid;
      });
      if (exists) {
        this.$util.errorMsg("该校区已添加");
        this.selectedCampusUnid = null;
        return;
      }
      // 查找校区信息
      const campus = this.campusZoneList.find((item) => {
        return item.value === this.selectedCampusUnid;
      });
      if (campus) {
        this.formData.campusList = [...this.formData.campusList, campus];
        this.selectedCampusUnid = null;
      }
    },
    // 删除校区
    handleDeleteCampus(unid) {
      const index = this.formData.campusList
        .map((item) => item.value)
        .indexOf(unid);
      if (index > -1) {
        this.formData.campusList.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
.school-section {
  width: 100%;
}

.school-select-row {
  margin-bottom: 16px;
}

.school-scope-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.school-scope-row .label-text {
  font-size: 14px;
  color: #606266;
  margin-right: 12px;
}

.campus-zone-section {
  margin-top: 8px;
}

.section-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

.campus-list-wrap {
  box-sizing: border-box;
  width: 100%;
  min-height: 120px;
  max-height: 200px;
  overflow: auto;
  padding: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5;
}

.campus-item {
  display: inline-block;
  margin: 0 4px 4px;
  padding: 4px 8px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5;
  background-color: #f5f7fa;
}

.campus-item span {
  margin-right: 4px;
}

.campus-footer {
  margin-top: 4px;
  text-align: right;
  font-size: 14px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// MineDetail.vue?32d2558a